import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import i18next from 'i18next';

import { PageLevelAccess } from '../PageLevelAccess';
import { SelectInput } from '../SelectInput';
import { TextInput } from '../TextInput';
import { GroupingsService } from '../../services';

const validate = values => {
    const errors = {};

    if (!values.fullName) {
        errors.fullName = i18next.t('messages.please-enter-full-name');
    }

    return errors;
}

@connect(state => {
    return {
      form: state.form
    }
  })
class ChecklistUserForm extends React.Component {
    constructor(props) {
        super(props);

        const initData = {
            fullName: this.props.checklistUser ? this.props.checklistUser.fullName : '',
            deviceGroupings: this.props.checklistUser ? this.props.checklistUser.deviceGroupings.map(grouping => ({value: grouping.id, label: grouping.name})) : []
        };

        this.props.initialize(initData);

        this.state = {
            showDeleteModal: false
        };
    }

    componentDidMount() {
        GroupingsService.listAll().then((response) => {
            this.setState({ groupingOptions: response.groupings.map(grouping => ({value: grouping.id, label: grouping.name}))});
          }).catch((error) => {
            console.error(error);
            this.props.onError(i18next.t('messages.could-not-load-groupings'));
          });
    }

    toggleDeleteModal() {
        this.setState({showDeleteModal: !this.state.showDeleteModal});
    }

    render() {
        if (!this.state.groupingOptions) {
            return (<div className="loader">{i18next.t('loading')}</div>);
        } else {
            return (
            <div className="login-form">
                <form onSubmit={this.props.handleSubmit}>
                    <div className="form-group">
                        <Field
                            name="fullName"
                            type="text"
                            component={TextInput}
                            label={i18next.t('form-labels.name')}
                        />
                        <div className="form-group">
                            <label>{i18next.t('form-labels.locations')}</label>
                           <Field
                            name="deviceGroupings"
                            options={this.state.groupingOptions}
                            component={SelectInput}
                            isMulti
                            /> 
                        </div>
                     </div>
                     <ul className="list-inline clearfix">
                        <li className="pull-left"><button className="btn btn-primary" type="submit">{i18next.t('form-labels.save')}</button></li>
                        <li className="pull-left"><Link to={ this.props.backLinkWithParams ? this.props.backLinkWithParams.link : "/config/checklist/users"}><button className="btn btn-default">{i18next.t('form-labels.cancel')}</button></Link></li>
                        { this.props.onArchive &&
                        <PageLevelAccess to='/config/checklist/users/edit/:checklistUserId#delete'>
                            <li className="pull-right"><a className="btn btn-danger" onClick={this.toggleDeleteModal.bind(this)}>{i18next.t('delete')}</a></li>
                        </PageLevelAccess>
                        }
                    </ul>
                    <Modal show={this.state.showDeleteModal} onHide={this.toggleDeleteModal.bind(this)}>
                        <Modal.Header closeButton>
                            <Modal.Title>{i18next.t('pages.checklist-users.delete-checklist-user')}: {this.props.form.ChecklistUserForm.values ? this.props.form.ChecklistUserForm.values.fullName : ''}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <p>{i18next.t('messages.are-you-sure-delete')}</p> <br />
                        </Modal.Body>
                        <Modal.Footer>
                            <a className="btn btn-danger" onClick={this.props.onArchive}>{i18next.t('form-labels.save')}</a>
                            <Button onClick={this.toggleDeleteModal.bind(this)}>{i18next.t('form-labels.cancel')}</Button>
                        </Modal.Footer>
                    </Modal>
                </form>
            </div>
            );
        }
    }
}

export default reduxForm({form: 'ChecklistUserForm', validate})(ChecklistUserForm);